var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.profile)?_c('div',{key:"2",staticClass:"fill-height",staticStyle:{"width":"95%","margin":"0px auto","position":"relative"}},[(_vm.profile.leadUser)?_c('LeadUserDashboard'):_c('ClientDashboard')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }